import { render, staticRenderFns } from "./DeleteVirtualDomainModal.vue?vue&type=template&id=09990bee&"
import script from "./DeleteVirtualDomainModal.vue?vue&type=script&lang=js&"
export * from "./DeleteVirtualDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports